export default "__VITE_ASSET__BRogGl_3__"